import React, { useEffect, useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const WishlistPage = () => {
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const res = await api.get("/api/wishlist", { withCredentials: true });
        setWishlist(res.data || []);
      } catch (err) {
        console.error("Error fetching wishlist:", err);
      }
    };
    fetchWishlist();
  }, []);

  const getThumbnailUrl = (episodeId) =>
    `/${episodeId}-thumbnail.jpg`; // Update path as per structure

  const getSeasonFromEpId = (epId) => {
    if (epId.startsWith("AIE-SE01")) return "season-one-episodes";
    if (epId.startsWith("AIE-SE02")) return "season-two-episodes";
    return "unknown-season";
  };

  const grouped = [];
  for (let i = 0; i < wishlist.length; i += 2) {
    grouped.push(wishlist.slice(i, i + 2));
  }

  return (
    <div className="p-8 font-['EB_Garamond','Nunito','sans-serif']">

      {grouped.map((row, i) => (
        <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
          {row.map((ep) => (
            <div
              key={ep.episode_id}
              className="relative border-[2px] border-[rgb(234,126,93)] rounded-md overflow-hidden"
            >
              <img
                src={getThumbnailUrl(ep.episode_id)}
                alt="Episode Thumbnail"
                className="w-full h-[200px] object-cover"
              />
              <button
                className="absolute bottom-4 left-1/2 transform -translate-x-1/2 px-4 py-2 bg-[rgb(234,126,93)] text-white font-semibold hover:bg-opacity-90 transition"
                onClick={() => navigate(`/${getSeasonFromEpId(ep.episode_id)}`)}
              >
                Watch Now
              </button>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default WishlistPage;